import { cn } from "@/lib/class-control"
import { toast } from "@/hooks/use-toast"

interface StepNavigationProps {
  totalSteps: number
  onStepChange: (step: number) => void
  getStepStatus: (step: number) => "complete" | "current" | "incomplete" | "locked"
}

export function StepNavigation({
  totalSteps,
  onStepChange,
  getStepStatus,
}: StepNavigationProps) {
  const handleStepClick = (step: number) => {
    const status = getStepStatus(step)
    if (status === "locked") {
      toast({
        title: "Acesso bloqueado",
        description: `Complete o Step ${step - 1} antes de continuar`,
        variant: "destructive",
      })
      return
    }

    onStepChange(step)
  }

  return (
    <div className="w-full">
      <ol className="flex items-center justify-center mb-8 gap-[60px]">
        {Array.from({ length: totalSteps }).map((_, idx) => {
          const step = idx + 1
          const status = getStepStatus(step)

          return (
            <li key={step} className="flex items-center relative">
              {step < totalSteps && (
                <div className="absolute left-[40px] top-1/2 -translate-y-1/2 w-24 h-[1px] bg-[#5d5d5d]" />
              )}
              <button
                type="button"
                onClick={() => handleStepClick(step)}
                className={cn(
                  "flex items-center justify-center w-[50px] h-[50px] rounded-full shrink-0 transition-colors relative z-10 font-['Plus_Jakarta_Sans'] text-[20px]",
                  status === "complete" && "bg-[#13d480] text-white",
                  status === "current" && "bg-[#13d480] text-white",
                  status === "incomplete" && "bg-[#15203c] text-white",
                  status === "locked" && "bg-[#15203c] text-white cursor-not-allowed"
                )}
                disabled={status === "locked"}
              >
                {step}
              </button>
            </li>
          )
        })}
      </ol>
    </div>
  )
}
